import { gql }  from '@apollo/client';

const VENDOR_POINTS = gql`
  query ($id: ID!) {
  	member(id: $id){
      vendorPoints{
        vendorNm
        category
        vendorDetails
      }
    }
  }
`;

export default VENDOR_POINTS;
